import { RootState } from '../store'
import { createSelector } from 'reselect'



const selectParameterDetailsState = (state: RootState) => state.parameterDetails.data
const loading = (state: RootState) => state.parameterDetails.loading
const error = (state: RootState) => state.parameterDetails.error
const selectSelectedParameter = (state: RootState) => state.parameterDetails.selectedParameter

const makeSelectedParameterRanges = createSelector(
  [selectParameterDetailsState],
  (details): {allowable_range:[number, number] | null, values: {value: number, color: string}[]} | null => {
    if(!details) {return null}
    const {values=[], colors=[], allowable_range} = details
    const concat_values = values.reduce((acc, curr, idx)=> {
      acc.push( {
        value: curr,
        color: colors[idx] || colors[colors.length - 1],

      })
      return acc
    }, [] as {value: number, color: string}[])

    return {
      allowable_range,
      values: concat_values
    }
  }
)

export const ParameterDetailsSelector = {
  selectParameterDetailsState,
  loading,
  error,
  selectSelectedParameter,
  makeSelectedParameterRanges,
}
